import styled from 'styled-components';
import { Button } from '../../../components/utils/Button/Button';

export const PageContainer = styled.div`
  padding: 2.4rem 1.6rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  margin-top: 2.4rem;
  flex-grow: 1;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 2.4rem;
  border-radius: 16px;
  border: 1px solid #f3f4f6;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
`;

export const PhotoList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.2rem;
`;

export const PhotoItem = styled.div`
  position: relative;
  width: 15rem;
  height: 15rem;
  border-radius: 4.933px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const RemovePhotoButton = styled.button`
  position: absolute;
  top: 0.6rem;
  right: 0.6rem;
  width: 2.8rem;
  height: 2.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  cursor: pointer;

  svg {
    width: 1.6rem;
    height: 1.6rem;
  }
`;

export const GenerateButton = styled(Button)`
  width: 20rem;
`;
